import React from 'react';
import * as util from "../../../other/util.js";
import FleetFormulas from "../../../share/formulas/fleet-formulas.js";
import FleetStep from "./fleet-step.js";

export class PendingStationFleetStep extends FleetStep {
    constructor() {
        super("STATION");
    }

    render(props, idx) {
        let fleet = props.fleet;
        let location = props.prediction.getLocation();

        let foo = (planet) => {
            if (!planet) {
                return (<span>Loading ...</span>);
            }

            if (!planet.name) {
                return (<span>No planet here, this task will fail.</span>);
            }

            if (!planet.buildings) {
                return (<span>Unknown.</span>);
            }

            let duration = FleetFormulas.getTimeForLoadingResources(fleet.resources, planet.buildings.space_port);
            return (<util.NiceInlineTimeSpan timeSpan={duration} />);
        };

        return (
            <div>
                <span>
                    <span className="boring-info-text">Unloading time: </span>
                    <util.PlanetDependentTime x={location.x} y={location.y} z={location.z} callback={foo} />
                </span>
            </div>);
    }
}

export class FixedStationFleetStep extends FleetStep {
    render(props, idx) {
        let task = props.task;
        let step = task.steps[idx];

        if (this._isStepDone(props, idx)) {
            return this._renderDone("Stationing", idx);
        }

        let timer = (<util.NiceInlineTimeSpan timeSpan={step.duration} />);
        if (task.index === 0 && task.current_step === idx) {
            timer = (<util.Timer date={step.finished} style={{ display: "inline" }} />);
        }

        return (
            <div>
                <span>
                    <span className="boring-info-text">Unloading time: </span>
                    {timer}
                </span>
            </div>);
    }
}
